export default {
  content: {
    title: "Booking",
    searchPlaceholder: "Search candidate name, job position",
    listOfBooking: "List of booking",
    noDataFound: "No data found",
  },

  tableHead: {
    interviewDate: "Interview Date",
    interviewTime: "Time",
    candidateName: "Candidate Name",
    jobPosition: "Position",
    status: "Status",
  },
};
